import { axios } from '@/utils/request'

export function getRecord (id) {
  return axios({
    url: '/device/record/' + id,
    method: 'get'
  })
}

export function getMonthlyUpgradeData () {
  return axios({
    url: '/device/record-monthly',
    method: 'get'
  })
}
